import { GlobalState } from 'ha/types/store';

const getPageInfo = (state: GlobalState) => state.search.pageInfo;

export const getNumberOfListings = (state: GlobalState): number =>
  getPageInfo(state).total;

export { getPageInfo };
